"use strict";
import { createSlice } from "@reduxjs/toolkit";
import { isPoolSearchResult, SearchResultType } from "features/search/SearchResult";
const SEARCH_HISTORY_LENGTH = 5;
export function searchResultId(searchResult) {
  const { type } = searchResult;
  const address = isPoolSearchResult(searchResult) ? searchResult.poolId : searchResult.address;
  const normalizedAddress = address?.toLowerCase() ?? null;
  switch (type) {
    case SearchResultType.Token:
      return `token-${searchResult.chainId}-${normalizedAddress}`;
    case SearchResultType.ENSAddress:
      return `ens-${normalizedAddress}`;
    case SearchResultType.Unitag:
      return `unitag-${normalizedAddress}`;
    case SearchResultType.WalletByAddress:
      return `wallet-${normalizedAddress}`;
    case SearchResultType.Etherscan:
      return `etherscan-${normalizedAddress}`;
    case SearchResultType.NFTCollection:
      return `nftCollection-${searchResult.chainId}-${normalizedAddress}`;
    case SearchResultType.Pool:
      return `pool-${searchResult.chainId}-${normalizedAddress}-${searchResult.feeTier}`;
  }
}
export const initialSearchHistoryState = {
  results: []
};
const slice = createSlice({
  name: "searchHistory",
  initialState: initialSearchHistoryState,
  reducers: {
    addToSearchHistory: (state, action) => {
      const { searchResult } = action.payload;
      const searchId = searchResultId(searchResult);
      state.results.unshift({ ...searchResult, searchId });
      state.results = state.results.filter((result, index, self) => index === self.findIndex((value) => value.searchId === result.searchId)).slice(0, SEARCH_HISTORY_LENGTH);
    },
    clearSearchHistory: (state) => {
      state.results = [];
    }
  }
});
export const { addToSearchHistory, clearSearchHistory } = slice.actions;
export const { reducer: searchHistoryReducer } = slice;
